import { FC, ReactNode } from 'react';
import { Tag } from 'antd';
import { CheckCircleOutlined, CloseCircleOutlined, SyncOutlined } from '@ant-design/icons';

import type { StringPair } from '@pmp/api';

type ProductBoSyncStatusProps = {
  status?: StringPair | null;
};

const TAGS: Record<string, { color: string; icon: ReactNode }> = {
  OK: { color: 'success', icon: <CheckCircleOutlined /> },
  PENDING: { color: 'processing', icon: <SyncOutlined /> },
  FAILED: { color: 'error', icon: <CloseCircleOutlined /> },
};

export const ProductBoSyncStatus: FC<ProductBoSyncStatusProps> = ({ status }) => {
  if (!status) return '-';

  const tag = TAGS[status.key];

  return (
    <Tag color={tag?.color} icon={tag?.icon}>
      {status.value}
    </Tag>
  );
};
